define('models/Session',[
    'jquery',
    'core/can',
    'moment',
    'core/oidc-configuration',
    // 'models/User',
    'models/Account',
    'models/Provider',
    'text!content/js/Enums.json',
    'jquery-cookie'
], function ($, can, moment, OidcConfig, Account, Provider, constants) {
    constants = $.parseJSON(constants);

    var tokenKey = 'accessToken';
    var identityTokenKey = 'identityToken';
    var legacyToken = 'legacyToken';
    var nalaUrl = 'https://nala.axxessweb.com/';

    return new (can.Map.extend({

        define: {
			/*User: {
				Type: User
			},*/
            Providers: {
                Type: Provider.List
            }
        },

        start: function () {
            var self = this;
            var token = this.getTokenFromUrl() || this.getCookie();
            var accountId = this.getAccountFromUrl();
            var isCheckingNala = false;
            
            if (token) {
                this.clearCookie()
                isCheckingNala = true;
                this.checkForNalaRedirect(token)
                .then(function(nalaAccountId) {
                    if (nalaAccountId) {
                        window.location.href = nalaUrl + '?accountId=' + nalaAccountId;
                    } else {
                        self.clearToken();
                        self.clearIdentityToken();
                        self.clearAccountId();
                        self.cacheLegacyToken(token);
                        if (accountId) {
                            self.handleAccountIdInUrl(accountId);
                        }
                        var defs = [];
                        return $.when.apply($, defs).then(function () {
                            can.trigger(self, 'started');
                        });
                    }
                });

            }

            if (accountId) {
                this.handleAccountIdInUrl(accountId);
            }

            var defs = [];
            if (!isCheckingNala) {
                return $.when.apply($, defs).then(function () {
                    can.trigger(self, 'started');
                });
            }
        },

        handleAccountIdInUrl: function (accountId) {
            var accountInfo = this.getAccountInfo();
            if (accountInfo !== accountId) {
                this.clearToken();
                this.clearIdentityToken();
            }
            this.setAccountInfo(accountId);
        },

        setToken: function (self, data) {
            self.cacheToken(data);
            return self.hydrate(data);
        },

        hydrate: function (data) {
            var self = this,
                defs = [],
                isDemo = (data.accountId === '5519b914d12fb6260ba8d98d'),
                repLoginId = data.repLoginId,
                isAuthBillers = (
                    repLoginId
                    && (
                        repLoginId === '1e0b5339-ee96-4b6d-ba4b-f54e180b2495'
                        || repLoginId === '126b4b91-92ee-4e9c-b975-f3135063be0d'
                    )
                );

            // Demo Account
            if (isDemo && config.api_url !== "https://demorcmapi.axxessweb.com") {
                config.api_url = "https://demorcmapi.axxessweb.com";
            }

            this.attr({
                Token: data.access_token,
                AccountId: data.accountId,
                AccountType: data.accounttype,
                UserId: data.userid,
                FirstName: data.firstname,
                LastName: data.lastname,
                LastLogin: data.lastLogin,
                isReadOnly: data.isReadOnly === 'True',
                isDarkDay: data.isDarkDay === 'True',
                hideMedia: data.hideMedia === 'True',
                trialExpirationDate: data.trialExpirationDate,
                allowedIdleTime: (isLocal || config.isStaging) ? 120 : 10, // in minutes
                idleWarningTime: 2, // in minutes
                userPermission: data.userPermissions,
                medicarePermission: data.medicarePermissions,
                isImpersonating: data.isImpersonating === 'True',
                isAuthorizedBiller: data.isAuthorizedBiller === 'True' || isAuthBillers,
                isBillingClient: data.isBillingClient === 'True',
                repLoginId: repLoginId,
                newMedia: {
                    title: 'How to use AxxessDDE?',
                    videoUrl: 'https://fast.wistia.net/embed/iframe/8uqnfo86x3?autoPlay=true',
                    isWisitaEmbed: true
                },
                identityToken: ''
            });
            this.resetIdleExpiryTime();

            if (isDemo) {
                this.attr({
                    FirstName: null,
                    LastName: 'Demo'
                });
            }

            // Providers
            defs.push(this.attr('_isVendor')
                ? $.when(Account.findChildren(), Provider.findAll())
                    .then(function (accounts, providers) {
                        return self.attr({
                            'Accounts': accounts,
                            'Providers': providers
                        });
                    })
                : Provider.findAll()
                    .then(function (providers) {
                        return self.attr('Providers', providers);
                    })
            );
        },

        destroy: function () {
            this.clearToken();
            this.clearIdentityToken();
            var oidcConfig = new OidcConfig();
            oidcConfig.oidcSignOut();
            // Event triggered before Session is cleared so that app can
            // be unloaded and the views and models that depend on Session will not throw errors
            can.trigger(this, 'destroyed');
            this.attr({}, true);

        },

        // ----------------------------------------
        // Authentication
        // ----------------------------------------

        getCookie: function () {
            var token = $.cookie('.AXXESSOAUTH');
            return (token === undefined) ? false : token;
        },

        // ----------------------------------------
        // Authorization
        // ----------------------------------------

        cacheToken: function (token) {
            localStorage.setItem(tokenKey, JSON.stringify(token));
        },

        cacheIdentityToken: function (token) {
            localStorage.setItem(identityTokenKey, JSON.stringify(token));
        },

        cacheLegacyToken: function (token) {
            localStorage.setItem(legacyToken, token);
        },

        clearToken: function () {
            localStorage.removeItem(tokenKey);
        },

        clearIdentityToken: function () {
            localStorage.removeItem(identityTokenKey);
        },
        clearLegacyToken: function () {
            localStorage.removeItem(legacyToken);
        },

        clearCookie: function () {
            $.removeCookie('.AXXESSOAUTH', { path: '/' , domain: '.axxessweb.com'});
        },

        clearAccountId: function () {
            localStorage.removeItem('AccountId');
        },

        clearCookie: function () {
            $.removeCookie('.AXXESSOAUTH', { path: '/' , domain: '.axxessweb.com'});
        },

        getTokenFromUrl: function () {
            var token = can.route.attr('token');
            can.route.removeAttr('token');
            return (!!token) ? token : false;
        },

        getAccountFromUrl: function () {
            var accountId = can.route.attr('accountId');
            can.route.removeAttr('accountId');
            return (!!accountId) ? accountId : false;
        },

        getTokenFromStorage: function () {
            var token = JSON.parse(localStorage.getItem(tokenKey));
            if (token && token['.expires'] && Date.parse(token['.expires']) > Date.now()) {
                return token;
            } else {
                this.clearToken();
                return false;
            }
        },

        getIdentityTokenFromStorage: function () {
            var token = JSON.parse(localStorage.getItem(identityTokenKey));
            if (token && token['expires_at'] && (token['expires_at']*1000) > Date.now()) {
                return token;
            } else {
                this.clearIdentityToken();
                return false;
            }
        },

        getLegacyTokenFromStorage: function () {
            return localStorage.getItem(legacyToken);
        },

        getAccountInfo: function () {
            return window.localStorage.getItem('AccountId');
        },

        setAccountInfo: function (accountId) {
            window.localStorage.setItem('AccountId', accountId);
        },

        editDataInStorage: function (key, newValue) {
            var token = JSON.parse(localStorage.getItem(tokenKey));
            if (token != null) {
                token[key] = newValue;
                this.cacheToken(token);
            }
        },

        resetIdleExpiryTime: function () {
            localStorage.setItem('idleExpiry', JSON.stringify(moment().add(this.attr('allowedIdleTime'), 'm')));
        },

        checkForNalaRedirect: function (token) {
            return can.ajax({
                type: 'POST',
                url: '/Token/NewDdeId',
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                data: {
                    grant_type: 'custom',
                    accesstoken: token,
                }
            });
        },

        getTokenFromServer: function (cookie, accountId) {
            // We send the token back to the application, asking if it's valid, 
            // and letting the application fill our claims and user info.
            return can.ajax({
                type: 'POST',
                url: '/Token',
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                data: {
                    grant_type: 'custom',
                    accesstoken: cookie,
                    accountid: accountId
                }
            });
        },

        getTokenFromServerUsingIdentity: function (cookie, accountInfo) {
            return can.ajax({
                type: 'POST',
                url: '/Token/Identity',
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                data: {
                    grant_type: 'custom',
                    accesstoken: cookie,
                    accountid: accountInfo
                }
            });
        },

        // ----------------------------------------
        // Helpers
        // ----------------------------------------

        _FullName: can.compute(function () {
            var f = this.attr('FirstName'),
                l = this.attr('LastName');
            return (f && l) ? f + ' ' + l : f || l || '';
        }),

        _isVendor: can.compute(function () {
            switch (this.attr('AccountType')) {
                case 2:
                case 'Vendor':
                    return true;
                case 1:
                case 'Regular':
                default:
                    return false;
            }
        }),

        filterParams: can.compute(function () {
            var o = {};
            // filterAccountId and filterProviderId is set in VendorFilterComponent
            if (this.attr('filterAccountId'))
                o.AccountId = this.attr('filterAccountId');
            if (this.attr('filterProviderId'))
                o.ProviderId = this.attr('filterProviderId');
            return o;
        }),
        
        getProvidersList: can.compute(function () {
            var providers = {};
            if (this.attr('Providers')){
                    providers = this.attr('Providers');
            }   
            return providers;
        })
    }));

	/* 
	TODO
	This doesn't work because they have different formats. eg lastLogin and LastLogin.
	Session.bind('change', function() {
		this.cacheToken();
	});
	*/

});
